import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import TDialogStyle from './TDialogStyles';
import CloseIcon from '@material-ui/icons/Close';

function TDialog(props) {
    const {
        fullScreen,
        open,
        handleClose,
        dialogContentText,
        dialogTitle,
        dialogActions,
        closeButton,
        classes
    } = props;

    return (
        <Dialog
            fullScreen={fullScreen}
            disableBackdropClick={true}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
        >
            {closeButton ? (
                <div className={classes.closeIconDiv}>
                    <IconButton className={classes.closeIconButton} onClick={handleClose}>
                        <CloseIcon className={classes.closeIcon} />
                    </IconButton>
                </div>
            ) : null}

            <DialogTitle id="responsive-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{dialogContentText}</DialogContentText>
            </DialogContent>
            <DialogActions>{dialogActions}</DialogActions>
        </Dialog>
    );
}

export default withStyles(TDialogStyle)(TDialog);
